/* J HERBS — cart page summary (assets/jh-cart-page.js)  v2 · 30 Oct 2026
   Same job as before (free-delivery bar, shipping, Duties & Services, total).
   Changes: totals are worked out from the line items; money is shown the same
   way as the rest of the page (£12.99, not "GBP 12.99"). */
(function () {
  var cfg = window.jhCartPageConfig || {}, i18n = cfg.i18n || {},
    shipBarEl = document.getElementById('jhCpShipBar'), shippingRowEl = document.getElementById('jhCpShippingRow'),
    dutiesRowEl = document.getElementById('jhCpDutiesRow'), grandTotalEl = document.getElementById('jhCpGrandTotal');
  if (!grandTotalEl) return;

  function getRate() { return window.Shopify && Shopify.currency && Shopify.currency.rate ? parseFloat(Shopify.currency.rate) : 1; }
  function moneyFmt(cents, code) {
    try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: code }).format(cents / 100); }
    catch (e) { return code + ' ' + (cents / 100).toFixed(2); }
  }
  function decode(s) { var t = document.createElement('textarea'); t.innerHTML = s || ''; return t.value; }

  fetch(cfg.cartUrl + '.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
    var code = cart.currency, rate = getRate(), isSar = code === 'SAR',
      threshold = isSar ? 20000 : Math.round(cfg.freeShipThresholdCents * rate),
      estShipping = isSar ? 2000 : Math.round(cfg.ukShippingRateCents * rate),
      feeCents = 0, itemsTotal = 0;
    cart.items.forEach(function (it) {
      itemsTotal += it.final_line_price;
      if (it.handle === 'duties-and-services') feeCents += it.final_line_price;
    });

    function paintBar(forceFree) {
      var unlocked = typeof forceFree === 'boolean' ? forceFree : itemsTotal >= threshold;
      if (unlocked) {
        shipBarEl.innerHTML = '<div class="jh-cp-ship">🎉 ' + decode(i18n.freeUnlocked) + '<div class="bar"><div class="fill" style="width:100%"></div></div></div>';
      } else {
        var remaining = Math.max(1, threshold - itemsTotal), pct = Math.min(100, itemsTotal / threshold * 100);
        shipBarEl.innerHTML = '<div class="jh-cp-ship">' + decode(i18n.freeAwayPre) + ' <b>' + moneyFmt(remaining, code) + '</b> ' + decode(i18n.freeAwayPost) +
          '<div class="bar"><div class="fill" style="width:' + pct + '%"></div></div></div>';
      }
    }
    function paintShipping(shipCents) {
      shippingRowEl.innerHTML = shipCents === 0
        ? '<span>' + i18n.shipping + '</span><span class="jh-cp-free-tag">' + i18n.free + '</span>'
        : '<span>' + i18n.shipping + '</span><span>' + moneyFmt(shipCents, code) + '</span>';
      grandTotalEl.textContent = moneyFmt(itemsTotal + shipCents, code);
    }

    if (feeCents > 0) {
      dutiesRowEl.style.display = '';
      dutiesRowEl.innerHTML = '<span>' + decode(i18n.dutiesVat) + '</span><span>' + moneyFmt(feeCents, code) + '</span>';
    } else { dutiesRowEl.style.display = 'none'; dutiesRowEl.innerHTML = ''; }

    paintBar();
    paintShipping(itemsTotal >= threshold ? 0 : estShipping);
    if (window.jhRealShipping) {
      window.jhRealShipping().then(function (real) {
        if (!real || (real.currency && real.currency !== code)) return;
        paintBar(real.cents === 0);
        paintShipping(real.cents);
      }).catch(function () {});
    }
  });
})();